const HOMLEG = () => import('../views/Legislativo.vue')
const SECPLE = () => import('../views/SessaoPlenaria.vue')
const ORDIA = () => import('../views/OrdemDoDia.vue')
const PROC = () => import('../views/Processos.vue')
const AGED = () => import('../views/Agenda.vue')

export default [
  { name: 'viewLegislativo', path: '/legislativo', component: HOMLEG, meta: { acl: true } },
  { name: 'viewSessoes', path: '/atividades-legislativa/sessao-plenaria', component: SECPLE, meta: { acl: true } },
  { name: 'viewOrdemdodia', path: '/atividades-legislativa/ordem-do-dia', component: ORDIA, meta: { acl: true } },
  { name: 'viewProjetos', path: '/atividades-legislativa/projetos', component: PROC, meta: { acl: true } },
  { name: 'viewAgenda', path: '/atividades-legislativa/agenda', component: AGED, meta: { acl: true } }
]
